import { Flex, GridItem, Text, useBreakpointValue } from "@chakra-ui/react";
import * as React from "react";

function PathwayGridItem({ name }) {
  const translatePercentage = useBreakpointValue({
    base: "-100%",
    sm: "-50%",
    md: "0%",
    xl: "-50%"
  });

  return (
    <GridItem colSpan={2}>
      <Flex
        transform={`rotate(-90deg) translate(${translatePercentage})`}
        width="100%" height="100%" alignItems="center"
      >
        <Text fontWeight="bold" whiteSpace="nowrap">
          {name.charAt(0).toUpperCase() + name.slice(1)}
        </Text>
      </Flex>
    </GridItem>
  );
}

export default PathwayGridItem;